<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/commande-client/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <span *ngIf="currentStatus === 'tous'">({{ getStatusCount('Tous') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/commande-client/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <span *ngIf="currentStatus === 'brouillon'">({{ getStatusCount('Brouillon') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/commande-client/valide']" [class.active]="currentStatus === 'valide'" (click)="filterByStatus('valide')">
                    Valide <span *ngIf="currentStatus === 'valide'">({{ getStatusCount('Valide') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/commande-client/cree']" [class.active]="currentStatus === 'cree'" (click)="filterByStatus('cree')">
                    Créé <span *ngIf="currentStatus === 'cree'">({{ getStatusCount('Crée') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/commande-client/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <span *ngIf="currentStatus === 'annule'">({{ getStatusCount('Annulé') }})</span>
                </a>
            </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>

